import { createSlice } from '@reduxjs/toolkit'

// ✅ नए सदस्यता फ़ील्ड्स को शामिल करने के लिए User इंटरफ़ेस को अपडेट करें
// (यदि यह JS फ़ाइल है, तो ये कमेंट्स के रूप में या JSDoc के रूप में हो सकते हैं)
/**
 * @typedef {object} User
 * @property {string} _id
 * @property {string} name
 * @property {string} [email]
 * @property {string} [mobile]
 * @property {object} [avatar]
 * @property {string} [avatar.public_id]
 * @property {string} [avatar.url]
 * @property {string[]} [platform]
 * @property {string} [loginType]
 * @property {string[]} [role]
 * @property {string} [userStatus]
 * @property {boolean} [verified]
 * @property {string[]} [refreshToken]
 * @property {Date} [verifyExpire]
 * @property {number} [resetPasswordOtp]
 * @property {Date} [resetPasswordOtpExpire]
 * @property {boolean} [hasJoinedCommunity]
 * @property {Date} [joinedCommunityAt]
 * @property {string} [membershipTier] - NONE, BASIC, PREMIUM
 * @property {string} [membershipStatus] - ACTIVE, INACTIVE, PENDING, EXPIRED, CANCELLED, FREE_TRIAL, SPONSORED
 * @property {string} [membershipStartDate]
 * @property {string} [membershipEndDate]
 * @property {string} [lastPaymentDate]
 * @property {string} [currentTransactionId]
 * @property {boolean} [freeTrialUsed]
 * @property {boolean} [isSponsoredMember] // ✅ नया फ़ील्ड जोड़ा गया
 * @property {string} createdAt
 * @property {string} updatedAt
 */

const authSlice = createSlice({
    name: 'auth',
    initialState: { 
        token: null,
        /** @type {User | null} */
        user: null, // user ऑब्जेक्ट को null से इनिशियलाइज़ करें
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null // किसी भी त्रुटि संदेश के लिए
    },
    reducers: {
        setCredentials: (state, action) => {
            const { token, user } = action.payload; // ✅ अब payload में token और user दोनों शामिल होंगे
            state.token = token;
            state.user = user; // ✅ user ऑब्जेक्ट को सेट करें
            state.status = 'succeeded';
            state.error = null;
        },
        logOut: (state, action) => { // action पैरामीटर हटा दिया गया क्योंकि इसका उपयोग नहीं हो रहा था
            state.token = null;
            state.user = null;
            state.status = 'idle';
            state.error = null;
        },
        // ✅ उपयोगकर्ता प्रोफ़ाइल के आंशिक अपडेट के लिए एक नया रिड्यूसर
        updateUserProfile: (state, action) => {
            if (state.user) {
                state.user = { ...state.user, ...action.payload };
            }
        },
        setAuthLoading: (state, action) => { // लोडिंग स्थिति को प्रबंधित करने के लिए
            state.status = action.payload;
        },
        setAuthError: (state, action) => { // त्रुटि स्थिति को प्रबंधित करने के लिए
            state.error = action.payload;
        },
    }
})

export const { setCredentials, logOut, updateUserProfile, setAuthLoading, setAuthError } = authSlice.actions

export default authSlice.reducer

export const selectCurrentToken = (state) => state.auth.token
export const selectAuthUser = (state) => state.auth.user; // उपयोगकर्ता ऑब्जेक्ट को चयन करने के लिए
export const selectAuthStatus = (state) => state.auth.status; // स्थिति चयन करने के लिए
export const selectAuthError = (state) => state.auth.error; // त्रुटि चयन करने के लिए

// ✅ रोल-आधारित चयनकर्ता (आपके Welcome.js और RequireAuth.js में उपयोग किए जाने वाले)
export const selectIsAdmin = (state) => state.auth.user?.role?.includes('ADMIN');
export const selectIsManager = (state) => state.auth.user?.role?.includes('MANAGER');
export const selectIsMember = (state) => state.auth.user?.role?.includes('MEMBER'); // यदि ऐप में 'MEMBER' भूमिका का उपयोग होता है

